import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { performFullLogout } from '#core/auth/logout.ts'

export const Route = createFileRoute('/_authentication/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('auth')

  useEffect(() => {
    void performFullLogout().finally(() => {
      // Hard navigation (not an SPA route change) so the just-unregistered worker fully
      // releases the page. Through the v1 proxy this lands on v1's login with no v2 worker
      // left to intercept it; direct on v2 the app re-registers a clean worker on /login.
      window.location.replace('/login')
    })
  }, [])

  return (
    <div className="mt-5 pt-5 text-center text-secondary">{t('loggingOut')}</div>
  )
}
